/**
 * Códigos de erro de MENSAGEM que atravessam back → front (e back → plugin).
 *
 * Os três abaixo saem da escrita do `metadata` (ver `domains/message.ts`): o
 * consumidor é o plugin, pela API, mas o front traduz do mesmo dicionário — é
 * o mesmo contrato.
 *
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const MESSAGE_ERRORS = {
  /** 400 — `metadata` não é objeto simples (array, texto, número, booleano). */
  METADATA_INVALID: "ERR_MESSAGE_METADATA_INVALID",
  /** 400 — o plugin tentou escrever no namespace de outro plugin. */
  METADATA_FOREIGN_NAMESPACE: "ERR_MESSAGE_METADATA_FOREIGN_NAMESPACE",
  /** 413 — passou do teto de bytes (por namespace ou da mensagem) ou de chaves. */
  METADATA_TOO_LARGE: "ERR_MESSAGE_METADATA_TOO_LARGE"
} as const;

export type MessageErrorCode = (typeof MESSAGE_ERRORS)[keyof typeof MESSAGE_ERRORS];
